import { FC, useEffect } from "react";

import { Form, Modal } from "antd";

import AdditionalFieldForm from "components/additional-field-form";

import { AdditionalField } from "types";

const AdditionalFieldModal: FC<{
  visible: boolean;
  initialValues?: Partial<AdditionalField>;
  onClose: () => void;
  onSuccess: (val: AdditionalField) => void;
  useInFormView?: boolean;
}> = ({ onClose, onSuccess, visible, initialValues, useInFormView }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      initialValues && form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [visible, initialValues]);

  return (
    <Modal
      onOk={() => {
        form.submit();
      }}
      open={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <AdditionalFieldForm
        useInFormView={useInFormView}
        form={form}
        canEditForm
        error={undefined}
        mutateAdditionalFields={() => null}
        onSuccess={(val) => {
          onSuccess(val);
          onClose();
        }}
      />
    </Modal>
  );
};

export default AdditionalFieldModal;
